type PersonNamePart = string | null | undefined;

export function toPersonFullname(
  lastName: PersonNamePart,
  firstName: PersonNamePart,
  middleName?: PersonNamePart,
) {
  return [lastName, firstName, middleName].filter(Boolean).join(" ");
}
